module.exports = __webpack_public_path__ + "static/media/1.782a5a03.png";